export default "__VITE_ASSET__1122e06a__"